export default __webpack_public_path__ + "static/media/background-logo.49455d1c.png";